import { useState } from "react";
import { getFinanceYearlyComparisonApi } from "../api/financeYearlyComparison";
import { useAuth } from "./useAuth";

export function useFinanceYearlyComparison() {
  const { auth } = useAuth(); // ✅ aquí se obtiene el token

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchComparison = async (yearA, yearB) => {
    try {
      setLoading(true);
      setError(null);

      const result = await getFinanceYearlyComparisonApi(auth.token, yearA, yearB);
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, fetchComparison };
}
